const countryListWithDuplicates = [
  { key: 'fr-ma', value: 'Morocco' },
  { key: 'ma-fr', value: 'Morocco' },
  { key: 'nl-nl', value: 'Netherlands' },
  { key: 'NL', value: 'Netherlands' },
  { key: 'es-mx', value: 'Mexico' },
  { key: 'mx-es', value: 'Mexico' },
  { key: 'it-it', value: 'Italy' },
  { key: 'it', value: 'Italy' },
  { key: 'ITA', value: 'Italy' },
  { key: 'cn-zh', value: 'China' },
  { key: 'CHN', value: 'China' },
  { key: 'zh-hans', value: 'China' },
  { key: 'es-es', value: 'Spain' },
  { key: 'de-de', value: 'Germany' },
  { key: 'DE', value: 'Germany' },
  { key: 'pl-pl', value: 'Poland' },
  { key: 'fr-fr', value: 'France' },
  { key: 'ae-en', value: 'UAE' },
  { key: 'en-ae', value: 'UAE' },
  { key: 'gb-en', value: 'United Kingdom' },
  { key: 'en-gb', value: 'United Kingdom' },
  { key: 'au-en', value: 'Australia' },
  { key: 'en-au', value: 'Australia' },
  { key: 'en-nz', value: 'New Zealand' },
  { key: 'nz-en', value: 'New Zealand' },
  { key: 'be-en', value: 'Belgium' },
  { key: 'en-be', value: 'Belgium' },
  { key: 'jp-jp', value: 'Japan' },
  { key: 'ja', value: 'Japan' },
  { key: 'us-en', value: 'United States' },
  { key: 'en-us', value: 'United States' },
  { key: 'in-en', value: 'India' },
  { key: 'en-in', value: 'India' },
  { key: 'en-in', value: 'India' },
  { key: 'en-in', value: 'India' },
  { key: 'no-no', value: 'Norway' },
  { key: 'SE', value: 'Sweden' },
  { key: 'se-en', value: 'Sweden' },
  { key: 'en-se', value: 'Sweden' },
  { key: 'NO', value: 'Norway' },
  { key: 'ro-en', value: 'Romania' },
  { key: 'en-ro', value: 'Romania' },
  { key: 'RO', value: 'Romania' },
  { key: 'at-de', value: 'Austria' },
  { key: 'AT', value: 'Austria' },
  { key: 'en-pt', value: 'Portugal' },
  { key: 'pt-en', value: 'Portugal' },
  { key: 'PRT', value: 'Portugal' },
  { key: 'PT', value: 'Portugal' },
  { key: 'co-es', value: 'Colombia' },
  { key: 'es-co', value: 'Colombia' },
  { key: 'CO', value: 'Colombia' },
  { key: 'fr-fr', value: 'France' },
  { key: 'en-gb', value: 'United Kingdom' },
  { key: 'au-en', value: 'Australia' },
  { key: 'nz-en', value: 'New Zealand' },
  { key: 'BE', value: 'Belgium' },
  { key: 'ja', value: 'Japan' },
  { key: 'jp-jp', value: 'Japan' },
  { key: 'en-us', value: 'United States' },
  { key: 'en-in', value: 'India' },
  { key: 'SE', value: 'Sweden' },
  { key: 'no-no', value: 'Norway' },
  { key: 'se-en', value: 'Sweden' },
  { key: 'NO', value: 'Norway' },
  { key: 'RO', value: 'Romania' },
  { key: 'en-ro', value: 'Romania' },
  { key: 'at-de', value: 'Austria' },
  { key: 'de-at', value: 'Austria' },
  { key: 'AT', value: 'Austria' },
  { key: 'PT', value: 'Portugal' },
  { key: 'DK', value: 'Denmark' },
  { key: 'FI', value: 'Finland' },
  { key: 'CH', value: 'Switzerland' },
  { key: 'en-ch', value: 'Switzerland' },
  { key: 'ch-en', value: 'Switzerland' },
  { key: 'DK', value: 'Denmark' },
  { key: 'dk-en', value: 'Denmark' },
  { key: 'FI', value: 'Finland' },
  { key: 'CH', value: 'Switzerland' },
  { key: 'en-ch', value: 'Switzerland' },
  { key: 'ch-en', value: 'Switzerland' },
  { key: 'HU', value: 'Hungary' },
  { key: 'pt-br', value: 'Brazil' },
  { key: 'cz-en', value: 'Czech Republic' },
  { key: 'en-cz', value: 'Czech Republic' },
  { key: 'en-CZ', value: 'Czech Republic' },
  { key: 'CZ', value: 'Czech Republic' },
  { key: 'CZE', value: 'Czech Republic' },
  { key: 'sg-en', value: 'Singapore' },
  { key: 'en-sg', value: 'Singapore' },
  { key: 'ar-es', value: 'Argentina' },
  { key: 'es-ar', value: 'Argentina' },
  { key: 'ca-fr', value: 'Canada' },
  { key: 'ca-en', value: 'Canada' },
  { key: 'en-ca', value: 'Canada' },
  { key: 'en-hk', value: 'Hong Kong SAR' },
  { key: 'sa-ar', value: 'Saudi Arabia' },
  { key: 'HU', value: 'Hungary' },
  { key: 'pt-br', value: 'Brazil' },
  { key: 'CZ', value: 'Czech Republic' },
  { key: 'en-sg', value: 'Singapore' },
  { key: 'es-ar', value: 'Argentina' },
  { key: 'fr-ma', value: 'Morocco' },
  { key: 'en-ca', value: 'Canada' },
  { key: 'en-hk', value: 'Hong Kong SAR' },
  { key: 'en-my', value: 'Malaysia' },
  { key: 'en-ph', value: 'Philippines' },
  { key: 'tn-fr', value: 'Tunisia' },
  { key: 'ma-en', value: 'Morocco' },
  { key: 'en-ma', value: 'Morocco' },
  { key: 'lu-en', value: 'Luxembourg' },
  { key: 'en-lu', value: 'Luxembourg' },
  { key: 'ro-en', value: 'Romania' },
  { key: 'en-ro', value: 'Romania' },
  { key: 'ie-en', value: 'Ireland' },
  { key: 'en-ie', value: 'Ireland' },
  { key: 'hu-en', value: 'Hungary' },
  { key: 'en-hu', value: 'Hungary' },
  { key: 'tn-en', value: 'Tunisia' },
  { key: 'sk-en', value: 'Slovakia' },
  { key: 'en-sk', value: 'Slovakia' },
  { key: 'ua-en', value: 'Ukraine' },
  { key: 'en-ua', value: 'Ukraine' },
  { key: 'en-tn', value: 'Tunisia' },
  { key: 'en-fi', value: 'Finland' },
  { key: 'en-se', value: 'Sweden' },
  { key: 'en-dk', value: 'Denmark' },
  { key: 'dk-en', value: 'Denmark' },
  { key: 'en-no', value: 'Norway' },
  { key: 'no-en', value: 'Norway' },
  { key: 'en-hu', value: 'Hungary' },
  { key: 'ph-en', value: 'Philippines' },
  { key: 'my-en', value: 'Malaysia' },
  { key: 'hk-en', value: 'Hong Kong SAR' },
  { key: 'ca-en', value: 'Canada' },
  { key: 'sg-en', value: 'Singapore' },
  { key: 'gb-en', value: 'United Kingdom' },
  { key: 'en-ae', value: 'UAE' },
  { key: 'ae-en', value: 'UAE' },
  { key: 'en-gr', value: 'Greece' },
  { key: 'gr-en', value: 'Greece' },
  { key: 'en-rs', value: 'Serbia' },
  { key: 'rs-en', value: 'Serbia' }
];

// Removing duplicates
const countryListMap = new Map(countryListWithDuplicates.map(item => [item.key, item.value]));

// Converting map to array of objects in required format
const countryList = [];
countryListMap.forEach((value, key) => {
  countryList.push({
    key,
    value
  });
});

export {
  countryList
};
